<div class="activity activity-list-item" *ngFor="let child; index as i; of: getActivities()">
  <xs-activity
    [activity]="child"
    [activityTypeId]="child.activityTypeId"
    [isSPPMode]="isSPPMode"

    (onDelete)="onDelete(child)"
    (onUpdate)="onUpdate.emit(child)"
    (onRefresh)="onRefresh.emit()"
    [isFooter]="i === activities.length"
    [canEdit]="canEdit"
    (isEditting)="isEditting.emit($event)"
  ></xs-activity>
</div>

<div sa-file-download class="ng-hide"></div>
